module.exports = __webpack_public_path__ + "img/dian_7163d88fc.png";